var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5310_9628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.447 24.9969H20.893V19.4279C20.893 18.0999 20.866 16.3909 19.041 16.3909C17.188 16.3909 16.905 17.8359 16.905 19.3299V24.9969H13.351V13.5449H16.765V15.1059H16.811C17.288 14.2059 18.448 13.2559 20.181 13.2559C23.782 13.2559 24.448 15.6259 24.448 18.7109L24.447 24.9969ZM9.337 11.9779C9.06588 11.9781 8.79739 11.9247 8.54691 11.821C8.29642 11.7172 8.06886 11.5651 7.87724 11.3733C7.68562 11.1815 7.5337 10.9538 7.43019 10.7032C7.32668 10.4526 7.27361 10.184 7.274 9.91292C7.2742 9.5047 7.39544 9.10571 7.6224 8.76639C7.84936 8.42708 8.17184 8.16269 8.54907 8.00665C8.92629 7.85062 9.34131 7.80994 9.74165 7.88978C10.142 7.96961 10.5097 8.16637 10.7982 8.45516C11.0867 8.74396 11.2831 9.11182 11.3625 9.51224C11.442 9.91265 11.4009 10.3276 11.2445 10.7047C11.0881 11.0818 10.8234 11.404 10.4839 11.6306C10.1443 11.8573 9.74522 11.9781 9.337 11.9779ZM11.119 24.9969H7.555V13.5449H11.119V24.9969ZM26.225 4.54492H5.771C4.792 4.54492 4 5.31892 4 6.27392V26.8159C4 27.7719 4.792 28.5449 5.771 28.5449H26.222C27.2 28.5449 28 27.7719 28 26.8159V6.27392C28 5.31892 27.2 4.54492 26.222 4.54492H26.225Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5310_9628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4.54492)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5a5ca96300f0de97dc4090155db1974c.svg";
export { ForwardRef as ReactComponent };